export default "__VITE_ASSET__Beh9Lz_F__"